import React, { useState } from 'react'

import { connect } from 'react-redux'

import {
  Grid,
  AppBar,
  Button,
  IconButton,
  List,
  ListItem,
  Menu,
  Tooltip,
  Typography,
  useMediaQuery,
  Box,
} from '@mui/material'

import { ArrowBack } from '@mui/icons-material'

import {
  setSidebarToggleMobile,
  setNotificationsDrawerToggle,
} from '../../reducers/ThemeOptions'
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined'
import withSession from '@/housefolios-components/Session/withSession'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate, useLocation } from 'react-router'

import {
  getPublicBrandLinkSx,
  getPublicBrandLogoWrapSx,
  getPublicNavButtonSx,
} from './publicNavButtonSx'
import {
  publicHeaderBarSx,
  publicHeaderRootSx,
} from '@/layout-blueprints/chromeSx'
import {
  publicNavFlexSpacerSx,
  publicNavMenuBtnSx,
  publicNavRowMarginSx,
  publicNavWhiteIconSx,
} from '@/layout-blueprints/chromeComponentSx'
import aerialView from '@/assets/images/AerialView.jpg'
import {
  introHeadingSx,
  introLeadInSx,
  introTextSx,
} from '@/housefolios-components/PublicPages/publicPageSx'
import { getNextLevelLogoProps } from '@/housefolios-components/PublicPages/shared/nextLevelBranding'

const Header = (props) => {
  const {
    headerShadow,
    headerBgTransparent,
    sidebarToggleMobile,
    setSidebarToggleMobile,
    subdomainParam,
    orgName,
    marketplace,
  } = props

  const hiddenMdDown = useMediaQuery((theme) =>
    theme.breakpoints.down('md'),
  )
  const hiddenMdUp = useMediaQuery((theme) =>
    theme.breakpoints.up('md'),
  )

  const toggleSidebarMobile = () => {
    setSidebarToggleMobile(!sidebarToggleMobile)
  }

  let navigate = useNavigate()
  const location = useLocation()
  const isHome = location.pathname === '/'
  const { logoSrc, logoAlt } = getNextLevelLogoProps(marketplace)
  const marketplaceTitle = `${marketplace ? marketplace.name : 'Housefolios'} Marketplace`

  const goBack = () => {
    navigate(-1)
  }

  const [anchorElMainMenu, setAnchorElMainMenu] = useState(null)
  const handleClickMainMenu = (event) => {
    setAnchorElMainMenu(event.currentTarget)
  }
  const handleCloseMainMenu = () => {
    setAnchorElMainMenu(null)
  }

  return (
    // <header
    // style={{ left: 0 }}>
    //   <div>
    //     {/* <button
    //       onClick={toggleSidebarMobile}>
    //       <span>
    //         <span />
    //       </span>
    //     </button> */}
    //     {/* {props.collapsed && ( */}
    //       {/* <Tooltip title="Previous Page">
    //         <IconButton onClick={goBack}>
    //           <KeyboardBackspaceOutlinedIcon />
    //         </IconButton>
    //       </Tooltip> */}
    //     {/* )} */}
    //     {/* <HeaderSearch /> */}
    //     {/* <HeaderMenu /> */}
    //   </div>
    //   <div>
    //     <Grid container direction="row" spacing={2}>
    //       {/* <Grid key="Navigation">
    //         <Grid container direction='row' alignItems='center' justifyContent='space-between' wrap='nowrap'>
    //           <Grid>
    //             <Typography>Navigation</Typography>
    //           </Grid>
    //         </Grid>
    //       </Grid> */}
    //       <Grid key="Home">
    //         <Button component="a" href={"/" + subdomainParam} style={{ color: 'white', borderBottom: window.location.pathname === '/' ? 'solid' : '' }}>
    //           Home
    //         </Button>
    //       </Grid>
    //       <Grid key="Properties">
    //         <Button component="a" href={"/properties" + subdomainParam} style={{ color: 'white', borderBottom: window.location.pathname === '/properties' ? 'solid' : '' }}>
    //           Properties
    //         </Button>
    //       </Grid>
    //       <Grid key="Sold Properties">
    //         <Button component="a" href={"/soldproperties" + subdomainParam} style={{ color: 'white', borderBottom: window.location.pathname === '/soldproperties' ? 'solid' : '' }}>
    //           Sold Properties
    //         </Button>
    //       </Grid>
    //       {props.marketplace && (
    //         <Grid key="Team">
    //           <Button component="a" href={"/team" + subdomainParam} style={{ color: 'white', borderBottom: window.location.pathname === '/team' ? 'solid' : '' }}>
    //             Team
    //           </Button>
    //         </Grid>
    //       )}
    //       {/* {props.marketplace && (
    //         <Grid key="Blog">
    //           <Button component="a" href={null} style={{ color: 'white' }}>
    //             Blog
    //           </Button>
    //         </Grid>
    //       )} */}
    //       <Grid key="Contact Us">
    //         <Button component="a" href={null} onClick={null} style={{ color: 'white' }}>
    //           Contact Us
    //         </Button>
    //       </Grid>
    //     </Grid>
    //     {/* <HeaderDrawer /> */}
    //   </div>
    //   <container style={{ textAlign: 'center' }}>
    //     <div>
    //       <div>{orgName ? orgName : 'Housefolios'} Marketplace</div>
    //       <div>Buy Properties Today!</div>
    //     </div>
    //   </container>
    // </header>
    <Box component="div" id="wrapper" sx={publicHeaderRootSx}>
      <AppBar
        position="relative"
        elevation={0}
        color="transparent"
        component="header"
        id="js-header"
        sx={[
          publicHeaderBarSx(isHome),
          isHome && {
            textAlign: 'center',
            color: '#fff !important',
            backgroundColor: 'transparent',
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${aerialView })`,
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'scroll',
            backgroundPosition: 'center center',
            backgroundSize: 'cover',
          },
        ]}
      >
        <Box
          sx={{
            '&::after': {
              display: 'block',
              clear: 'both',
              content: '""',
            },
          }}
        >
          <Grid container direction="row" spacing={1} sx={[{
            width: "100%",
            "& .MuiListItem-root, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
            "& .MuiListItem-root, & .MuiListItemButton-root, .MuiList-root.nav-transparent-alt .MuiListItem-root, .MuiList-root.nav-transparent-alt .MuiListItemButton-root": { width: "100%" },
            "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
          }, publicNavRowMarginSx(isHome), { justifyContent: 'flex-end', alignItems: 'center' }, {
            "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
              color: "#368cff",
              background: "rgba(54, 140, 255, 0.05)",
              "&::before": { background: "#368cff" },
            },
          }]}>
            <Grid data-hf-grid="keep">
              <Tooltip title="Previous Page">
                <IconButton onClick={goBack} size="large">
                  <KeyboardBackspaceOutlinedIcon sx={publicNavWhiteIconSx} />
                </IconButton>
              </Tooltip>
            </Grid>
            {!isHome && (
              <Grid data-hf-grid="keep" sx={{ minWidth: 0, flex: '1 1 auto' }}>
                <Button
                  component="a"
                  href={'/' + subdomainParam}
                  title={marketplaceTitle}
                  color="inherit"
                  sx={getPublicBrandLinkSx()}
                >
                  {logoSrc ? (
                    <Box sx={getPublicBrandLogoWrapSx()}>
                      <Box
                        component="img"
                        src={logoSrc}
                        alt={logoAlt || ''}
                      />
                    </Box>
                  ) : null}
                  <Box
                    component="span"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      color: '#fff',
                    }}
                  >
                    {marketplaceTitle}
                  </Box>
                </Button>
              </Grid>
            )}
            {isHome && <Typography sx={publicNavFlexSpacerSx} />}
            {hiddenMdDown ? null : (
              <>
                <Grid key="Home">
                  <Button
                    component="a"
                    href={
                      marketplace?.url ===
                      'nlinvesting.housefolios.com'
                        ? 'https://nextlevelpropertyinvesting.com/home/'
                        : '/' + subdomainParam
                    }
                    sx={getPublicNavButtonSx(isHome)}
                  >
                    Home
                  </Button>
                </Grid>
                <Grid key="Properties">
                  <Button
                    component="a"
                    href={'/properties' + subdomainParam}
                    sx={getPublicNavButtonSx(
                      location.pathname === '/properties',
                    )}
                  >
                    View Properties
                  </Button>
                </Grid>
                <Grid key="Sold Properties">
                  <Button
                    component="a"
                    href={'/soldproperties' + subdomainParam}
                    sx={getPublicNavButtonSx(
                      location.pathname === '/soldproperties',
                    )}
                  >
                    Sold Properties
                  </Button>
                </Grid>
                {props.marketplace && (
                  <Grid key="Team">
                    <Button
                      component="a"
                      href={'/team' + subdomainParam}
                      sx={getPublicNavButtonSx(
                        location.pathname === '/team',
                      )}
                    >
                      Team
                    </Button>
                  </Grid>
                )}
                {props.marketplace &&
                  marketplace?.url ===
                    'nlinvesting.housefolios.com' && (
                    <>
                      <Grid key="Education">
                        <Button
                          component="a"
                          href={'/education' + subdomainParam}
                            sx={getPublicNavButtonSx(
                              location.pathname === '/education',
                            )}
                        >
                          Education
                        </Button>
                      </Grid>
                      <Grid key="Turnkey">
                        <Button
                          component="a"
                          href={'/turnkey' + subdomainParam}
                            sx={getPublicNavButtonSx(
                              location.pathname === '/turnkey',
                            )}
                        >
                          Turnkey
                        </Button>
                      </Grid>
                      <Grid key="Cities">
                        <Button
                          component="a"
                          href={'/cities' + subdomainParam}
                            sx={getPublicNavButtonSx(
                              location.pathname === '/cities',
                            )}
                        >
                          Cities
                        </Button>
                      </Grid>
                    </>
                  )}
                {/* {props.marketplace && (
                <Grid key="Blog">
                  <Button component="a" href={null} style={{ color: 'white' }}>
                    Blog
                  </Button>   
                </Grid>
              )} */}
                <Grid key="Contact Us">
                  <Button
                    component="a"
                    href={
                      marketplace?.url ===
                      'nlinvesting.housefolios.com'
                        ? 'https://nextlevelpropertyinvesting.com/contact-us/'
                        : '/' + subdomainParam + '#contactUs'
                    }
                    sx={getPublicNavButtonSx(false)}
                  >
                    Contact Us
                  </Button>
                </Grid>
              </>
            )}
            {hiddenMdUp ? null : (
              <>
                <Grid data-hf-grid="keep">
                  <IconButton
                    onClick={handleClickMainMenu}
                    sx={publicNavMenuBtnSx}
                    size="large"
                  >
                    <FontAwesomeIcon
                      icon={['fa', 'bars']}
                      sx={publicNavWhiteIconSx}
                    />
                  </IconButton>
                </Grid>
                <Menu
                  anchorEl={anchorElMainMenu}
                  keepMounted
                  open={Boolean(anchorElMainMenu)}
                  onClose={handleCloseMainMenu}
                  MenuListProps={{ sx: { p: 0 } }}
                  getContentAnchorEl={null}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                >
                  <Box sx={{ minWidth: "22rem" }}>
                    <List
                      component="div"
                      sx={{
                        "& .MuiListItem-root.MuiListItem-button": { borderRadius: 0 },
                        "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                          color: "#368cff",
                          background: "rgba(54, 140, 255, 0.05)",
                          "&::before": { background: "#368cff" },
                        },
                      }}
                    >
                      <ListItem
                        button
                        component="a"
                        href={
                          marketplace?.url ===
                          'nlinvesting.housefolios.com'
                            ? 'https://nextlevelpropertyinvesting.com/home/'
                            : '/' + subdomainParam
                        }
                      >
                        <span>Home</span>
                      </ListItem>
                      <ListItem
                        button
                        component="a"
                        href={'/properties' + subdomainParam}
                      >
                        <span>View Properties</span>
                      </ListItem>
                      <ListItem
                        button
                        component="a"
                        href={'/soldproperties' + subdomainParam}
                      >
                        <span>Sold Properties</span>
                      </ListItem>
                      <ListItem
                        button
                        component="a"
                        href={'/team' + subdomainParam}
                      >
                        <span>Team</span>
                      </ListItem>
                      {marketplace?.url ===
                        'nlinvesting.housefolios.com' && (
                        <>
                          <ListItem
                            button
                            component="a"
                            href={'/education' + subdomainParam}
                          >
                            <span>Education</span>
                          </ListItem>
                          <ListItem
                            button
                            component="a"
                            href={'/turnkey' + subdomainParam}
                          >
                            <span>Turnkey</span>
                          </ListItem>
                          <ListItem
                            button
                            component="a"
                            href={'/cities' + subdomainParam}
                          >
                            <span>Cities</span>
                          </ListItem>
                        </>
                      )}
                      <ListItem
                        button
                        component="a"
                        href={
                          marketplace?.url ===
                          'nlinvesting.housefolios.com'
                            ? 'https://nextlevelpropertyinvesting.com/contact-us/'
                            : '/' + subdomainParam + '#contactUs'
                        }
                        onClick={null}
                      >
                        <span>Contact Us</span>
                      </ListItem>
                    </List>
                  </Box>
                </Menu>
              </>
            )}
          </Grid>
        </Box>
        {isHome && (
          <Box sx={{ textAlign: 'center', width: '100%', flexShrink: 0 }}>
            <Box sx={introTextSx}>
              <Box sx={introLeadInSx}>
                {marketplaceTitle}
              </Box>
              <Box sx={introHeadingSx}>
                Buy Properties Today!
              </Box>
            </Box>
          </Box>
        )}
      </AppBar>
    </Box>
  )
}

const mapStateToProps = (state) => ({
  headerShadow: state.DeprecatedThemeOptions.headerShadow,
  headerBgTransparent:
    state.DeprecatedThemeOptions.headerBgTransparent,
  sidebarToggleMobile:
    state.DeprecatedThemeOptions.sidebarToggleMobile,
  notificationsDrawerToggle:
    state.DeprecatedThemeOptions.notificationsDrawerToggle,
})

const mapDispatchToProps = (dispatch) => ({
  setSidebarToggleMobile: (enable) =>
    dispatch(setSidebarToggleMobile(enable)),
  setNotificationsDrawerToggle: (enable) =>
    dispatch(setNotificationsDrawerToggle(enable)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSession(Header))
